var exports = {
  "e": "x28a7bf27--894590--program-button",
  "q": "x28a7bf27--894590--sticky",
};

module.exports = exports;
